import { render, staticRenderFns } from "./Overlays.vue?vue&type=template&id=0df32656&scoped=true&"
import script from "./Overlays.vue?vue&type=script&lang=js&"
export * from "./Overlays.vue?vue&type=script&lang=js&"
import style0 from "./Overlays.vue?vue&type=style&index=0&id=0df32656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df32656",
  null
  
)

export default component.exports